export default (data) => Object.keys(data).map((item) => data[item]);
